import React from 'react';

const ResultsList = ({ itemResults, onStoreCardClick }) => {
  let filteredResults = itemResults.filter(item => item.storeName !== null);
  filteredResults = filteredResults.sort((a, b) => {
    const aKey = a.promo != null && a.promo > 0 ? a.promo : a.price;
    const bKey = b.promo != null && b.promo > 0 ? b.promo : b.price;
    return aKey - bKey;
  });
  return (
    <section id="Results-List">
      <h2>Selected Item</h2>
      <div className="results-container">
        {filteredResults.map((item, index) => (
          <div
            className="results-item-container results-item-clickable"
            key={index}
            role="button"
            tabIndex={0}
            aria-label={
              item.storeName
                ? `Show ${item.storeName} on map`
                : 'Show store on map'
            }
            onClick={() => item.storeId && onStoreCardClick?.(item.storeId)}
            onKeyDown={(e) => {
              if (!item.storeId || !onStoreCardClick) {
                return;
              }
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onStoreCardClick(item.storeId);
              }
            }}
          >
            <div className="results-image">
              <img src={item.imageUrl || 'default-image.png'} alt={item.description} />
            </div>
            <div className="results-item-info">
              <h3>{item.description}</h3>
              <p>Price: ${item.price !== undefined ? item.price.toFixed(2) : 'Not Available'}</p>
              <p>Promo: {item.promo == null || item.promo === 0 ? 'None' : `$${item.promo}`}</p>
              <p>Location: {item.storeName}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ResultsList;
